import { PAGE_SIZE } from "./consts";

import type { NetworkPayload } from "../../../composites";

export const API = {
  fetchFileImports: (
    offsetIndex: number,
    pageSize = PAGE_SIZE,
    queryString?: string,
  ): NetworkPayload => {
    const qs = queryString ? `&${queryString}` : "";
    return {
      url: `file_imports?offset=${offsetIndex}&limit=${pageSize}${qs}`,
      options: {
        method: "GET",
      },
    };
  },
};
